import { jsx as _jsx } from "react/jsx-runtime";
import { BranchingQueryDefinition } from '@iotv/datamodel-core';
import { AdjacentType } from '@iotv/iotv-v3-types';
import { Skeleton, Stack } from '@mui/material';
import { useContext, useEffect } from 'react';
import { SingleObjectAutoQuery } from '../../../../../components/generic/ObjectAutoSearch';
import { NetworkCoverageContext } from '../../../NetworkCoverageContext';
import { populateNetworkCoverageContextFromProperty } from '../../queries/addAreasPlacesToContext';
const debug = process.env.REACT_APP_DEBUG && false;
export const PropertySelector = ({ contextCustomer }) => {
    // coverage state
    const { state: coverageState, dispatch: coverageDispatch } = useContext(NetworkCoverageContext);
    const { Properties, Areas, Places } = coverageState;
    const allSks = [...Areas.map((a) => a.sk), ...Places.map((p) => p.sk)];
    useEffect(() => {
        coverageDispatch({ type: 'setWizardAllowNext', allowNext: allSks.length > 0 });
    }, [allSks.length]);
    const handlePropertyChange = (property) => {
        debug && console.log('PropertySelector Property in selector change', property);
        coverageDispatch({ type: 'clearNEMContents', value: null, canaryString: 'clearCoverageMapNemOnPropertyChange' });
        if (contextCustomer) {
            populateNetworkCoverageContextFromProperty({ dispatch: coverageDispatch, properties: property ? [property] : [] });
        }
    };
    return contextCustomer ? (_jsx(Stack, { width: 250, children: _jsx(SingleObjectAutoQuery, { contextObject: contextCustomer, objectTypeId: "Property", query: new BranchingQueryDefinition({ id: contextCustomer.id, path: [{ adjacencyType: AdjacentType.CHILD, objectTypeId: 'Property' }] }), selectedObject: Properties.at(0), changeSelectedObject: handlePropertyChange }) })) : (_jsx(Skeleton, { variant: "rounded", height: '2.5em', width: '15.625em' }));
};
